if (!customElements.get('ly-custom-pergola-showcase')) {
    customElements.define('ly-custom-pergola-showcase', class extends HTMLElement {
        currentIndex = 0

        connectedCallback() {
            this.tabs = [...this.querySelectorAll('[data-tab-index]')]
            this.panels = [...this.querySelectorAll('[data-panel]')]
            this.mediaItems = [...this.querySelectorAll('[data-media]')]
            this.tabsScroller = this.querySelector('[data-tabs-scroller]')
            this.navigationButtons = [...this.querySelectorAll('[data-direction]')]

            if (!this.tabs.length || !this.panels.length) return

            const selectedIndex = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true')
            this.currentIndex = selectedIndex < 0 ? 0 : selectedIndex

            this.addEventListener('click', this.handleClick)
            this.addEventListener('keydown', this.handleKeydown)
            document.addEventListener('shopify:block:select', this.handleBlockSelect)

            this.navigationButtons.forEach(button => {
                button.disabled = this.tabs.length < 2
            })

            this.select(this.currentIndex)
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClick)
            this.removeEventListener('keydown', this.handleKeydown)
            document.removeEventListener('shopify:block:select', this.handleBlockSelect)
        }

        handleClick = (event) => {
            const tab = event.target.closest('[data-tab-index]')
            if (tab && this.contains(tab)) {
                this.select(Number(tab.dataset.tabIndex))
                return
            }

            const navigationButton = event.target.closest('[data-direction]')
            if (!navigationButton || !this.contains(navigationButton) || navigationButton.disabled) return

            const offset = navigationButton.dataset.direction === 'next' ? 1 : -1
            this.select(this.currentIndex + offset)
        }

        handleKeydown = (event) => {
            const tab = event.target.closest('[data-tab-index]')
            if (!tab || !this.contains(tab)) return

            const index = Number(tab.dataset.tabIndex)
            let targetIndex = null

            if (event.key === 'Home') targetIndex = 0
            if (event.key === 'End') targetIndex = this.tabs.length - 1
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = index + 1
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = index - 1

            if (targetIndex === null) return

            event.preventDefault()
            this.select(targetIndex, { focus: true })
        }

        handleBlockSelect = (event) => {
            if (!event.detail?.blockId) return

            const selectedTab = this.tabs.find(tab => tab.dataset.blockId === event.detail.blockId)
            if (!selectedTab) return

            this.select(Number(selectedTab.dataset.tabIndex))
        }

        select(index, { focus = false } = {}) {
            const normalizedIndex = (index + this.tabs.length) % this.tabs.length
            this.currentIndex = normalizedIndex

            this.tabs.forEach((tab, tabIndex) => {
                const isActive = tabIndex === normalizedIndex

                tab.classList.toggle('is-active', isActive)
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
                tab.tabIndex = isActive ? 0 : -1
            })

            this.panels.forEach((panel, panelIndex) => {
                panel.hidden = panelIndex !== normalizedIndex
            })

            this.mediaItems.forEach((media, mediaIndex) => {
                media.classList.toggle('is-active', mediaIndex === normalizedIndex)
            })

            const activeTab = this.tabs[normalizedIndex]
            if (focus) activeTab.focus()
            this.scrollTabIntoView(activeTab)

            this.dispatchEvent(new CustomEvent('ly:custom-pergola-showcase:change', {
                bubbles: true,
                detail: { index: normalizedIndex }
            }))
        }

        scrollTabIntoView(tab) {
            const scroller = this.tabsScroller

            if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return

            const scrollerRect = scroller.getBoundingClientRect()
            const tabRect = tab.getBoundingClientRect()

            const tabLeftInScroller =
                scroller.scrollLeft + tabRect.left - scrollerRect.left

            const targetLeft =
                tabLeftInScroller -
                (scroller.clientWidth - tabRect.width) / 2

            const maxScrollLeft =
                scroller.scrollWidth - scroller.clientWidth

            scroller.scrollTo({
                left: Math.min(Math.max(targetLeft, 0), maxScrollLeft),
                behavior: 'smooth'
            })
        }
    })
}

if (!window.__lyCustomPergolaShowcaseScrollBound) {
    window.__lyCustomPergolaShowcaseScrollBound = true

    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-buyer-scroll]')
        if (!button) return

        const section = button.closest('.ly-custom-pergola-showcase-section-container')
        if (!section) return

        const mobileTarget = Number(section.dataset.scrollTopMobile || 0)
        const desktopTarget = Number(section.dataset.scrollTopDesktop || mobileTarget)
        const top = window.matchMedia('(max-width: 767px)').matches ? mobileTarget : desktopTarget

        window.scrollTo({ top, behavior: 'smooth' })
    })
}
